export const isStaging = () =>
  typeof window !== "undefined"
    ? window.location.hostname.includes("flourishing-life-staging")
    : false;
